import React from "react";
import styled from "styled-components";
// Components
import ProductBox from "../Elements/ProductBox";
// Assets
import productImg1 from "../../assets/img/water-plants/well-water-desalination-plant.jpeg";
import productImg2 from "../../assets/img/water-plants/seawater-desalination-plant.jpeg";
import productImg3 from "../../assets/img/water-plants/industrial-wastewater-treatment-plant.jpeg";
import productImg4 from "../../assets/img/water-plants/softener-boiler-water-treatment-plant.jpeg";
import productImg5 from "../../assets/img/water-plants/water-sterilization.jpeg";
import productImg6 from "../../assets/img/water-plants/water-treatment-for-iron-and-manganese.jpeg";

export default function WaterPlants() {
  const Wrapper = styled.section`
    width: 100%;
  `;
  const LineSeparator = styled.hr`
    width: 25%;
    height: 3px;
    margin: auto;
    opacity: 1;
    border: none;
    margin: 3px auto;
  `;
  const HeaderInfo = styled.div`
    margin-auto;
    @media (max-width: 860px) {
      text-align: center;
    }
    & h2 {
      width: fit-content;
    }
  `;

  const data = [
    {
      productImg: productImg1,
      imgAlt: "محطة تحلية مياه أبار",
      title: "محطة تحلية مياه أبار",
    },
    {
      productImg: productImg2,
      imgAlt: "محطه تحليه مياه بحار",
      title: "محطه تحليه مياه بحار",
    },
    {
      productImg: productImg3,
      imgAlt: "محطه معالجه مياه صرف صناعى",
      title: "محطه معالجه مياه صرف صناعى",
    },
    {
      productImg: productImg4,
      imgAlt: "محطة معالجة مياه الغلايات سوفتنر",
      title: "محطة معالجة مياه الغلايات سوفتنر",
    },
    {
      productImg: productImg5,
      imgAlt: "تعقيم المياه",
      title: "تعقيم المياه",
    },
    {
      productImg: productImg6,
      imgAlt: "معالجة المياه من الحديد و المنجنيز",
      title: "معالجة المياه من الحديد و المنجنيز",
    },
  ];

  return (
    <Wrapper id="products">
      <div>
        <div className="container">
          <HeaderInfo>
            <h2 className="font40 extraBold m-auto darkColor">
              محطات المياه
              <LineSeparator className="cyanBg" />
            </h2>
          </HeaderInfo>
          <div className="row textCenter">
            {data.map((product) => {
              const { productImg, imgAlt, title } = product;
              return (
                <div key={title} className="col-xs-12 col-md-6 col-xl-4">
                  <ProductBox img={productImg} title={title} alt={imgAlt} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Wrapper>
  );
}
